import { Button } from '@mui/material';
import { useRouter } from 'next/navigation';

import type { ButtonProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

export interface GoBackButtonProps extends ButtonProps {
  children?: ReactNode;
}

export const GoBackButton: FC<GoBackButtonProps> = ({
  children = 'Go Back',
  ...props
}) => {
  const { back } = useRouter();

  return (
    <Button onClick={() => back()} {...props}>
      {children}
    </Button>
  );
};
